import React from 'react';
import { PRODUCT_NAME } from './constants';
export function Footer() {
  return <footer className="bg-brand-cream px-4 py-4 text-center" data-id="element-60" data-mp="3gezcx2w41p0m">
      <div className="mx-auto max-w-3xl space-y-1" data-id="element-61" data-mp="3ggk7utmc79z0">
        <p className="text-[11px] font-semibold text-brand-ink sm:text-xs" data-id="element-62" data-mp="32onigxc1ze6b">
          © 2026 {PRODUCT_NAME} — Tous Droits Réservés.
        </p>
        <p className="text-[11px] font-medium leading-snug text-brand-muted sm:text-xs" data-id="element-63" data-mp="36ppivhhphw9v">
          Ce système est fourni à des fins éducatives et de formation. Il est conçu pour aider à
          comprendre la domotique, planifier des systèmes connectés, configurer des appareils
          compatibles, créer des automatisations et organiser des projets. L’utilisateur reste
          responsable de l’utilisation des informations, de la vérification des spécifications des
          fabricants et du respect des réglementations et exigences de sécurité applicables. Les
          interventions électriques ou réglementées doivent être confiées à des professionnels
          qualifiés lorsque cela est nécessaire.
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-64" data-mp="3gagzxq623d49">
          Conditions Générales • Politique de Confidentialité • Contact
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-65" data-mp="3v9azhcaljycb">
          Support :{' '}
          <a href="mailto:kitonline27@gmail.com" className="font-semibold text-brand-orange hover:underline" data-id="element-66" data-mp="3q727ai5jt0b9">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}